import React from "react";

// ─── Fase 17 · Bloque 1 — Global ErrorBoundary ────────────────────────────
// Catches any render-time crash so the user never sees a black screen.
// Cannot use LangContext (it might be the source of the crash) — reads lang
// from localStorage with ES fallback.
const STRINGS = {
  es: {
    kicker: "ERROR",
    title: "Algo se ha roto",
    body: "Recarga la página — tu configuración no se pierde.",
    reload: "↺ recargar",
    details: "detalles técnicos",
  },
  en: {
    kicker: "ERROR",
    title: "Something broke",
    body: "Reload the page — your configuration is safe.",
    reload: "↺ reload",
    details: "technical details",
  },
};

function readLang() {
  try {
    const v = localStorage.getItem("lang");
    return v === "en" ? "en" : "es";
  } catch { return "es"; }
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    const L = STRINGS[readLang()] || STRINGS.es;
    return (
      <div data-testid="error-boundary"
           style={{ minHeight: "100vh", background: "#141618", color: "#D8D5C7",
                     display: "flex", alignItems: "center", justifyContent: "center",
                     padding: 24, fontFamily: "var(--plex), system-ui, sans-serif" }}>
        <div style={{ maxWidth: 420, width: "100%", padding: 28,
                       border: "1px solid #C49E50", background: "rgba(42, 48, 50, 0.40)" }}>
          <div style={{ color: "#C49E50", fontFamily: "var(--mono), monospace",
                          fontSize: 10, letterSpacing: 0.25, marginBottom: 12 }}>
            {L.kicker}
          </div>
          <h2 style={{ color: "#E8E4D3", fontSize: 20, margin: "0 0 8px", fontWeight: 400 }}>
            {L.title}
          </h2>
          <p style={{ margin: "0 0 18px", fontSize: 13, lineHeight: 1.6 }}>
            {L.body}
          </p>
          <button onClick={() => window.location.reload()}
                  data-testid="error-reload"
                  style={{ background: "transparent", border: "1px solid #C49E50",
                            color: "#C49E50", padding: "8px 18px", cursor: "pointer",
                            fontFamily: "var(--mono), monospace", fontSize: 12,
                            letterSpacing: 0.18 }}>
            {L.reload}
          </button>
          <details style={{ marginTop: 18, color: "#7A7466", fontSize: 11 }}>
            <summary style={{ cursor: "pointer", letterSpacing: 0.1 }}>{L.details}</summary>
            <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word",
                            marginTop: 8, fontSize: 10, color: "#9A9382" }}>
              {String(this.state.error?.message || this.state.error || "Unknown error")}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}
